import React from 'react';

const QuestionCard = ({ 
  questionNumber, 
  totalQuestions, 
  questionText, 
  selectedAnswer, 
  onAnswerSelect 
}) => {
  const answerOptions = [
    { value: 1, label: 'Never', points: 1 },
    { value: 2, label: 'Rarely', points: 2 },
    { value: 3, label: 'Sometimes', points: 3 },
    { value: 4, label: 'Often', points: 4 },
    { value: 5, label: 'Almost Always', points: 5 }
  ];

  return (
    <div className="bg-brand-charcoal rounded-lg p-4 md:p-6 border border-brand-slate">
      <div className="mb-4 md:mb-6">
        <div className="text-brand-gold text-xs md:text-sm font-bold uppercase tracking-wide mb-2 md:mb-3">
          Question {questionNumber} of {totalQuestions}
        </div>
        <h2 className="text-base md:text-xl font-bold text-brand-white leading-snug md:leading-relaxed">
          {questionText}
        </h2>
      </div>

      <div className="space-y-2 md:space-y-3">
        {answerOptions?.map((option) => (
          <button
            key={option?.value}
            onClick={() => onAnswerSelect(option?.points)}
            className={`w-full flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-md border-2 transition-all duration-250 ${
              selectedAnswer === option?.points
                ? 'border-brand-gold bg-brand-gold/10' :'border-brand-slate bg-brand-black'
            }`}
            type="button"
            aria-pressed={selectedAnswer === option?.points}
          >
            <div className={`w-4 h-4 md:w-5 md:h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
              selectedAnswer === option?.points
                ? 'border-brand-gold' :'border-brand-steel'
            }`}>
              {selectedAnswer === option?.points && (
                <div className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-brand-gold" />
              )}
            </div>
            <span className={`text-sm md:text-base font-semibold ${
              selectedAnswer === option?.points
                ? 'text-brand-white' :'text-brand-steel'
            }`}>
              {option?.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;